import type { TOC } from '@ember/component/template-only';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import type Patient from 'parog-web/models/patient';
import AntecedentsFields from '../breast-cancer/antecedents-fields';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    patient: Patient;
  };
}

const MyComponent: TOC<Signature> = <template>
  <AntecedentsFields @form={{@form}} @patient={{@patient}} />
</template>;

export default MyComponent;
